export function calculateAge(birthdate: any): number {
  const today: Date = new Date();
  let age: number = today.getFullYear() - birthdate.getFullYear();
  const monthDiff: number = today.getMonth() - birthdate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdate.getDate())) {
    age--;
  }
  return age;
}

export function getTokenAuthorization() {
	const info = JSON.parse(localStorage.getItem('STORAGE_USER_INFO') as any) as any
	if (info?.token_type && info?.access_token) return `${info?.token_type} ${info?.access_token}`
	return ""
}

export const classList = [{
	"realGradeID": 13,
	"endAge": 6,
	"studySection": 1,
	"startAge": 1,
	"realGradeName": "学前"
}, {
	"realGradeID": 1,
	"endAge": 8,
	"studySection": 2,
	"startAge": 6,
	"realGradeName": "一年级"
}, {
	"realGradeID": 2,
	"endAge": 9,
	"studySection": 2,
	"startAge": 7,
	"realGradeName": "二年级"
}, {
	"realGradeID": 3,
	"endAge": 10,
	"studySection": 2,
	"startAge": 8,
	"realGradeName": "三年级"
}, {
	"realGradeID": 4,
	"endAge": 11,
	"studySection": 2,
	"startAge": 9,
	"realGradeName": "四年级"
}, {
	"realGradeID": 5,
	"endAge": 12,
	"studySection": 2,
	"startAge": 10,
	"realGradeName": "五年级"
}, {
	"realGradeID": 6,
	"endAge": 13,
	"studySection": 2,
	"startAge": 11,
	"realGradeName": "六年级"
}, {
	"realGradeID": 7,
	"endAge": 14,
	"studySection": 3,
	"startAge": 12,
	"realGradeName": "七年级"
}, {
	"realGradeID": 8,
	"endAge": 15,
	"studySection": 3,
	"startAge": 13,
	"realGradeName": "八年级"
}, {
	"realGradeID": 9,
	"endAge": 16,
	"studySection": 3,
	"startAge": 14,
	"realGradeName": "九年级"
}, {
	"realGradeID": 10,
	"endAge": 17,
	"studySection": 4,
	"startAge": 15,
	"realGradeName": "高一"
}, {
	"realGradeID": 11,
	"endAge": 18,
	"studySection": 4,
	"startAge": 16,
	"realGradeName": "高二"
}, {
	"realGradeID": 12,
	"endAge": 19,
	"studySection": 4,
	"startAge": 17,
	"realGradeName": "高三"
}, {
	"realGradeID": 15,
	"endAge": 20,
	"studySection": 5,
	"startAge": 18,
	"realGradeName": "大一"
}, {
	"realGradeID": 16,
	"endAge": 21,
	"studySection": 5,
	"startAge": 19,
	"realGradeName": "大二"
}, {
	"realGradeID": 17,
	"endAge": 22,
	"studySection": 5,
	"startAge": 20,
	"realGradeName": "大三"
}, {
	"realGradeID": 18,
	"endAge": 23,
	"studySection": 5,
	"startAge": 21,
	"realGradeName": "大四"
}, {
	"realGradeID": 19,
	"endAge": 24,
	"studySection": 6,
	"startAge": 22,
	"realGradeName": "研一"
}, {
	"realGradeID": 20,
	"endAge": 25,
	"studySection": 6,
	"startAge": 23,
	"realGradeName": "研二"
}, {
	"realGradeID": 21,
	"endAge": 26,
	"studySection": 6,
	"startAge": 24,
	"realGradeName": "研三"
}, {
	"realGradeID": 24,
	"endAge": 100,
	"studySection": 6,
	"startAge": 18,
	"realGradeName": "成人"
}]